import React from "react";
import "../css/background.css"

function Background(){
    return (
        <div className="background"></div>
    )
}

export default Background